import { render, staticRenderFns } from "./ErrorReportForm.vue?vue&type=template&id=b850cbe0&scoped=true&lang=html&"
import script from "./ErrorReportForm.vue?vue&type=script&lang=js&"
export * from "./ErrorReportForm.vue?vue&type=script&lang=js&"
import style0 from "./ErrorReportForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ErrorReportForm.vue?vue&type=style&index=1&id=b850cbe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b850cbe0",
  null
  
)

export default component.exports